import { api } from "@/shared/config/axiosConfig";
import { buildEndpoint } from "@/shared/utils/buildEndpoint";
import { validateRequiredFields } from "@/shared/utils/validateRequiredFields";
import { ruleFromDto } from "@/features/agreements/mappers/rulesMapper";

const BASE_ENDPOINT = 'rule-groups';

const buildServiceEndpoint = ({ ruleGroupId, ruleId, action } = {}) => {
  return buildEndpoint(BASE_ENDPOINT, { id: ruleGroupId }, ['rules', ruleId, action]);
};

/** El endpoint responde con un código 204 (No Content), por lo que no se retorna ningún valor. */
export const deleteRule = async (ruleGroupId, ruleId) => {
  validateRequiredFields({ ruleGroupId, ruleId });

  const endpoint = buildServiceEndpoint({ ruleGroupId, ruleId });
  await api.delete(endpoint);
};

export const restoreRule = async (ruleGroupId, ruleId) => {
  validateRequiredFields({ ruleGroupId, ruleId });

  const endpoint = buildServiceEndpoint({ ruleGroupId, ruleId, action: 'restore' });
  const response = await api.post(endpoint);
  return ruleFromDto(response.data);
};
